module.exports = __webpack_public_path__ + "static/cobblestones-7656e47a305441e3425f5d292a66265b.jpg";